/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../inputs/selection-field/selection-field.component.ngfactory';
import * as import2 from '../../inputs/selection-field/selection-field.component';
import * as import3 from 'ng2-translate/src/translate.service';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '@angular/forms';
import * as import6 from 'ng2-translate/src/translate.pipe';
import * as import7 from '../../notification/message/message.component.ngfactory';
import * as import8 from '../../notification/message/message.component';
import * as import9 from '../../notification/notification.service';
import * as import10 from '@angular/common';
import * as import11 from '../../buttons/link/link.component.ngfactory';
import * as import12 from '../../buttons/link/link.component';
import * as import13 from '../../page-layout/page-footer-control.directive';
import * as import14 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import15 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import16 from '../../orchestration/page';
import * as import17 from './ordering-context-edit-page.component';
import * as import18 from '../../buttons/button/button.component.ngfactory';
import * as import19 from '../../buttons/button/button.component';
import * as import20 from '../../orchestration/session.model';
import * as import21 from '../../orchestration/responsive.service';
import * as import22 from '../ordering-context.model';
import * as import23 from '../../order/order.model';
const styles_OrderingContextEditPageComponent:any[] = ([] as any[]);
export const RenderType_OrderingContextEditPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingContextEditPageComponent,
  data: {}
}
);
function View_OrderingContextEditPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-selection-field',[[
        'class',
        'context-selection'
      ]
    ],(null as any),[
      [
        (null as any),
        'onActivateField'
      ]
      ,
      [
        (null as any),
        'onActivateLink'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeStoreOrOrderType((undefined as any))) !== false);
        ad = (pd_0 && ad);
      }
      if (('onActivateLink' === en)) {
        const pd_1:any = ((<any>co.orderingContextModel.viewCurrentStore()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_SelectionFieldComponent_0,import1.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import2.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import3.TranslateService,
      import4.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      value: [
        2,
        'value'
      ]

    }
    ,{
      onActivateLink: 'onActivateLink',
      onActivateField: 'onActivateField'
    }
    ),
    import0.ɵqud(603979776,4,{optionComponents: 1}),
    import0.ɵprd(5120,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectionFieldComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.storeLabel;
    const currVal_1:any = 'woa.button.ordering-context.viewCurrentStore';
    const currVal_2:any = ((co.orderingContextModel.currentStore == null)? (null as any): co.orderingContextModel.currentStore.collectiveStoreName);
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_OrderingContextEditPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-selection-field',[[
        'class',
        'context-selection'
      ]
      ],(null as any),[[
        (null as any),
        'onActivateField'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeFulfilmentDetails()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_SelectionFieldComponent_0,import1.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import2.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import3.TranslateService,
      import4.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      value: [
        1,
        'value'
      ]

    }
    ,{onActivateField: 'onActivateField'}),
    import0.ɵqud(603979776,5,{optionComponents: 1}),
    import0.ɵprd(5120,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectionFieldComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.ordering-context.seatedAt';
    const currVal_1:any = co.orderingContextModel.currentTableNumberLabel;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingContextEditPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-selection-field',[[
        'class',
        'context-selection'
      ]
    ],(null as any),[
      [
        (null as any),
        'onActivateField'
      ]
      ,
      [
        (null as any),
        'onActivateLink'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeFulfilmentDetails()) !== false);
        ad = (pd_0 && ad);
      }
      if (('onActivateLink' === en)) {
        const pd_1:any = ((<any>co.orderingContextModel.changeFulfilmentDetails()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_SelectionFieldComponent_0,import1.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import2.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import3.TranslateService,
      import4.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      placeholder: [
        2,
        'placeholder'
      ]
      ,
      disabled: [
        3,
        'disabled'
      ]
      ,
      value: [
        4,
        'value'
      ]

    }
    ,{
      onActivateLink: 'onActivateLink',
      onActivateField: 'onActivateField'
    }
    ),
    import0.ɵqud(603979776,6,{optionComponents: 1}),
    import0.ɵprd(5120,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectionFieldComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.ordering-context.deliveringTo';
    const currVal_1:any = (co.orderingContextModel.addressTrusted? 'woa.button.ordering-context.changeDeliveryAddress': (undefined as any));
    const currVal_2:any = 'woa.label.ordering-context.enterDeliveryAddress';
    const currVal_3:any = co.orderingContextModel.addressTrusted;
    const currVal_4:any = co.confirmedAddress;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderingContextEditPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-selection-field',[[
        'class',
        'context-selection'
      ]
      ],(null as any),[[
        (null as any),
        'onActivateField'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeExpectedCompletion()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_SelectionFieldComponent_0,import1.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import2.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import3.TranslateService,
      import4.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      placeholder: [
        1,
        'placeholder'
      ]
      ,
      message: [
        2,
        'message'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]
      ,
      value: [
        4,
        'value'
      ]
      ,
      showMessageSpinner: [
        5,
        'showMessageSpinner'
      ]

    }
    ,{onActivateField: 'onActivateField'}),
    import0.ɵqud(603979776,7,{optionComponents: 1}),
    import0.ɵpod(['eta']),
    import0.ɵpid(131072,import6.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵprd(5120,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectionFieldComponent]),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.ordering-context.orderTime';
    const currVal_1:any = 'woa.label.ordering-context.selectOrderTime';
    const currVal_2:any = co.etaLabel;
    const currVal_3:any = ck(v,3,0,co.orderModel.orderEta);
    const currVal_4:any = import0.ɵunv(v,1,4,import0.ɵnov(v,4).transform(co.orderTime));
    const currVal_5:any = co.showTimeSpinner;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  },(null as any));
}
function View_OrderingContextEditPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',[[
        'class',
        'context-error'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import7.View_ContentMessageComponent_0,import7.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        2,
        4
      ]
    ],1,import8.ContentMessageComponent,[
      import0.ElementRef,
      import9.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,8,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.cannotAllocateOrderTimeMessage;
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextEditPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextEditPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.orderModel.cannotAllocateTime;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderingContextEditPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-link',[
      [
        'class',
        'change-order-type'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeOrderType()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import11.View_LinkComponent_0,import11.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import12.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import13.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.heading.ordering-context.changeOrderType';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_OrderingContextEditPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),30,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import14.View_ModalPageLayoutComponent_0,import14.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import15.ModalPageLayoutComponent,[
      import16.Page,
      import4.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      footerControlOrientation: [
        1,
        'footerControlOrientation'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import16.PageLayout,(null as any),[import15.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingContextEditPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingContextEditPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import10.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingContextEditPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import10.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingContextEditPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingContextEditPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import10.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import17.OrderingContextEditPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,26).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.navigationService.dismissPage(co)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import18.View_ButtonComponent_0,import18.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import19.ButtonComponent,[
      import0.ElementRef,
      import20.SessionModel,
      import0.ChangeDetectorRef,
      import21.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import13.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextEditPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import17.OrderingContextEditPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = 'vertical';
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = co.orderingContextModel.canChangeStore;
    ck(v,8,0,currVal_2);
    const currVal_3:any = (import0.ɵunv(v,11,0,import0.ɵnov(v,12).transform(co.OrderingContextEvents.orderType$)) === co.OrderType.ORDER_AT_TABLE);
    ck(v,11,0,currVal_3);
    const currVal_4:any = (import0.ɵunv(v,15,0,import0.ɵnov(v,16).transform(co.OrderingContextEvents.orderType$)) === co.OrderType.ORDER_DELIVERY);
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.orderingContextModel.canSelectOrderTime;
    ck(v,19,0,currVal_5);
    const currVal_6:boolean = !import0.ɵunv(v,22,0,import0.ɵnov(v,23).transform(co.OrderingContextEvents.evaluatingExpectedCompletionChange$));
    ck(v,22,0,currVal_6);
    const currVal_34:any = 'woa.button.common.continue';
    ck(v,26,0,currVal_34);
    const currVal_35:boolean = !co.orderingContextModel.singleOrderType;
    ck(v,30,0,currVal_35);
  },(ck,v) => {
    const currVal_7:any = import0.ɵnov(v,26).overrideFlatBackgroundColor;
    const currVal_8:any = import0.ɵnov(v,26).overrideFlatForegroundColor;
    const currVal_9:any = import0.ɵnov(v,26).overrideOutlineBackgroundColor;
    const currVal_10:any = import0.ɵnov(v,26).overrideOutlineForegroundColor;
    const currVal_11:any = import0.ɵnov(v,26).overrideOutlineBorderColor;
    const currVal_12:any = import0.ɵnov(v,26).overrideRaisedBackgroundColor;
    const currVal_13:any = import0.ɵnov(v,26).overrideRaisedForegroundColor;
    const currVal_14:any = import0.ɵnov(v,26).disabled;
    const currVal_15:any = import0.ɵnov(v,26).invisible;
    const currVal_16:any = import0.ɵnov(v,26).hovered;
    const currVal_17:any = import0.ɵnov(v,26).native;
    const currVal_18:any = import0.ɵnov(v,26).button;
    const currVal_19:any = import0.ɵnov(v,26).firstTier;
    const currVal_20:any = import0.ɵnov(v,26).secondTier;
    const currVal_21:any = import0.ɵnov(v,26).highProminence;
    const currVal_22:any = import0.ɵnov(v,26).lowProminence;
    const currVal_23:any = import0.ɵnov(v,26).affirmativeConnotation;
    const currVal_24:any = import0.ɵnov(v,26).dissuasiveConnotation;
    const currVal_25:any = import0.ɵnov(v,26).negativeConnotation;
    const currVal_26:any = import0.ɵnov(v,26).squareShape;
    const currVal_27:any = import0.ɵnov(v,26).roundedShape;
    const currVal_28:any = import0.ɵnov(v,26).ovalShape;
    const currVal_29:any = import0.ɵnov(v,26).flatStyle;
    const currVal_30:any = import0.ɵnov(v,26).outlineStyle;
    const currVal_31:any = import0.ɵnov(v,26).raisedStyle;
    const currVal_32:any = import0.ɵnov(v,26).verticalLayout;
    const currVal_33:any = import0.ɵnov(v,26).horizontalLayout;
    ck(v,25,1,[
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30,
      currVal_31,
      currVal_32,
      currVal_33
    ]
    );
  });
}
function View_OrderingContextEditPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-ordering-context-edit-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderingContextEditPageComponent_0,RenderType_OrderingContextEditPageComponent)),
    import0.ɵdid(49152,(null as any),0,import17.OrderingContextEditPageComponent,[
      import22.OrderingContextModel,
      import23.OrderModel,
      import4.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import16.Page,(null as any),[import17.OrderingContextEditPageComponent])
  ]
  ,(null as any),(null as any));
}
export const OrderingContextEditPageComponentNgFactory:import0.ComponentFactory<import17.OrderingContextEditPageComponent> = import0.ɵccf('woa-ordering-context-edit-page',import17.OrderingContextEditPageComponent,View_OrderingContextEditPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctY29udGV4dC9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9vcmRlcmluZy1jb250ZXh0L29yZGVyaW5nLWNvbnRleHQtZWRpdC1wYWdlL29yZGVyaW5nLWNvbnRleHQtZWRpdC1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctY29udGV4dC9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctY29udGV4dC9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS9vcmRlcmluZy1jb250ZXh0LWVkaXQtcGFnZS5jb21wb25lbnQudHMuT3JkZXJpbmdDb250ZXh0RWRpdFBhZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8d29hLW1vZGFsLXBhZ2UtbGF5b3V0IFt0aXRsZV09XCJ0aXRsZVwiIFtmb290ZXJDb250cm9sT3JpZW50YXRpb25dPVwiJ3ZlcnRpY2FsJ1wiPlxuICAgIDx3b2Etc2VsZWN0aW9uLWZpZWxkICpuZ0lmPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY2FuQ2hhbmdlU3RvcmVcIiBjbGFzcz1cImNvbnRleHQtc2VsZWN0aW9uXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbbGFiZWxdPVwic3RvcmVMYWJlbFwiIFtsaW5rXT1cIid3b2EuYnV0dG9uLm9yZGVyaW5nLWNvbnRleHQudmlld0N1cnJlbnRTdG9yZSdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIFt2YWx1ZV09XCJvcmRlcmluZ0NvbnRleHRNb2RlbC5jdXJyZW50U3RvcmU/LmNvbGxlY3RpdmVTdG9yZU5hbWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlRmllbGQpPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY2hhbmdlU3RvcmVPck9yZGVyVHlwZSh1bmRlZmluZWQpXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAob25BY3RpdmF0ZUxpbmspPVwib3JkZXJpbmdDb250ZXh0TW9kZWwudmlld0N1cnJlbnRTdG9yZSgpXCI+PC93b2Etc2VsZWN0aW9uLWZpZWxkPlxuICAgIDx3b2Etc2VsZWN0aW9uLWZpZWxkICpuZ0lmPVwiKE9yZGVyaW5nQ29udGV4dEV2ZW50cy5vcmRlclR5cGUkIHwgYXN5bmMpID09PSBPcmRlclR5cGUuT1JERVJfQVRfVEFCTEVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiY29udGV4dC1zZWxlY3Rpb25cIlxuICAgICAgICAgICAgICAgICAgICAgICAgIFtsYWJlbF09XCInd29hLmxhYmVsLm9yZGVyaW5nLWNvbnRleHQuc2VhdGVkQXQnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbdmFsdWVdPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY3VycmVudFRhYmxlTnVtYmVyTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlRmllbGQpPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY2hhbmdlRnVsZmlsbWVudERldGFpbHMoKVwiPjwvd29hLXNlbGVjdGlvbi1maWVsZD5cbiAgICA8d29hLXNlbGVjdGlvbi1maWVsZCAqbmdJZj1cIihPcmRlcmluZ0NvbnRleHRFdmVudHMub3JkZXJUeXBlJCB8IGFzeW5jKSA9PT0gT3JkZXJUeXBlLk9SREVSX0RFTElWRVJZXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImNvbnRleHQtc2VsZWN0aW9uXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbbGFiZWxdPVwiJ3dvYS5sYWJlbC5vcmRlcmluZy1jb250ZXh0LmRlbGl2ZXJpbmdUbydcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIFtsaW5rXT1cIm9yZGVyaW5nQ29udGV4dE1vZGVsLmFkZHJlc3NUcnVzdGVkID8gJ3dvYS5idXR0b24ub3JkZXJpbmctY29udGV4dC5jaGFuZ2VEZWxpdmVyeUFkZHJlc3MnIDogdW5kZWZpbmVkXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuYWRkcmVzc1RydXN0ZWRcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIFt2YWx1ZV09XCJjb25maXJtZWRBZGRyZXNzXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbcGxhY2Vob2xkZXJdPVwiJ3dvYS5sYWJlbC5vcmRlcmluZy1jb250ZXh0LmVudGVyRGVsaXZlcnlBZGRyZXNzJ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgKG9uQWN0aXZhdGVGaWVsZCk9XCJvcmRlcmluZ0NvbnRleHRNb2RlbC5jaGFuZ2VGdWxmaWxtZW50RGV0YWlscygpXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAob25BY3RpdmF0ZUxpbmspPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY2hhbmdlRnVsZmlsbWVudERldGFpbHMoKVwiPjwvd29hLXNlbGVjdGlvbi1maWVsZD5cbiAgICA8d29hLXNlbGVjdGlvbi1maWVsZCAqbmdJZj1cIm9yZGVyaW5nQ29udGV4dE1vZGVsLmNhblNlbGVjdE9yZGVyVGltZVwiIGNsYXNzPVwiY29udGV4dC1zZWxlY3Rpb25cIlxuICAgICAgICAgICAgICAgICAgICAgICAgIFtsYWJlbF09XCInd29hLmxhYmVsLm9yZGVyaW5nLWNvbnRleHQub3JkZXJUaW1lJ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgW3ZhbHVlXT1cIm9yZGVyVGltZSB8IHRyYW5zbGF0ZVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cIid3b2EubGFiZWwub3JkZXJpbmctY29udGV4dC5zZWxlY3RPcmRlclRpbWUnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbbWVzc2FnZV09XCJldGFMYWJlbFwiIFtzaG93TWVzc2FnZVNwaW5uZXJdPVwic2hvd1RpbWVTcGlubmVyXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbdHJhbnNsYXRpb25QYXJhbXNdPVwie2V0YTogb3JkZXJNb2RlbC5vcmRlckV0YX1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlRmllbGQpPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuY2hhbmdlRXhwZWN0ZWRDb21wbGV0aW9uKClcIj5cbiAgICA8L3dvYS1zZWxlY3Rpb24tZmllbGQ+XG4gICAgPG5nLWNvbnRhaW5lciAqbmdJZj1cIiEoT3JkZXJpbmdDb250ZXh0RXZlbnRzLmV2YWx1YXRpbmdFeHBlY3RlZENvbXBsZXRpb25DaGFuZ2UkIHwgYXN5bmMpXCI+XG4gICAgICAgIDx3b2EtY29udGVudC1tZXNzYWdlICpuZ0lmPVwib3JkZXJNb2RlbC5jYW5ub3RBbGxvY2F0ZVRpbWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImNvbnRleHQtZXJyb3JcIiBbbGV2ZWxdPVwiTWVzc2FnZUxldmVsLkVSUk9SXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3RleHRdPVwib3JkZXJNb2RlbC5jYW5ub3RBbGxvY2F0ZU9yZGVyVGltZU1lc3NhZ2VcIj48L3dvYS1jb250ZW50LW1lc3NhZ2U+XG4gICAgPC9uZy1jb250YWluZXI+XG4gICAgPHdvYS1idXR0b24gd29hLXBhZ2UtZm9vdGVyLWNvbnRyb2wgW2xhYmVsXT1cIid3b2EuYnV0dG9uLmNvbW1vbi5jb250aW51ZSdcIlxuICAgICAgICAgICAgICAgIChjbGljayk9XCJuYXZpZ2F0aW9uU2VydmljZS5kaXNtaXNzUGFnZSh0aGlzKVwiPjwvd29hLWJ1dHRvbj5cbiAgICA8d29hLWxpbmsgKm5nSWY9XCIhb3JkZXJpbmdDb250ZXh0TW9kZWwuc2luZ2xlT3JkZXJUeXBlXCIgd29hLXBhZ2UtZm9vdGVyLWNvbnRyb2wgY2xhc3M9XCJjaGFuZ2Utb3JkZXItdHlwZVwiXG4gICAgICAgICAgICAgIFtsaW5rXT1cIid3b2EuaGVhZGluZy5vcmRlcmluZy1jb250ZXh0LmNoYW5nZU9yZGVyVHlwZSdcIlxuICAgICAgICAgICAgICAob25BY3RpdmF0ZSk9XCJvcmRlcmluZ0NvbnRleHRNb2RlbC5jaGFuZ2VPcmRlclR5cGUoKVwiPjwvd29hLWxpbms+XG48L3dvYS1tb2RhbC1wYWdlLWxheW91dD5cbiIsIjx3b2Etb3JkZXJpbmctY29udGV4dC1lZGl0LXBhZ2U+PC93b2Etb3JkZXJpbmctY29udGV4dC1lZGl0LXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNDSTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFHcUI7UUFBQTtRQUFBO01BQUE7TUFDQTtRQUFBO1FBQUE7TUFBQTtNQUpyQjtJQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtnQkFBQTtNQUFBO0lBQUE7Ozs7SUFDcUI7SUFBcUI7SUFDckI7SUFGckIsU0FDcUIsVUFBcUIsVUFDckIsU0FGckI7Ozs7O01BS0E7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUlxQjtRQUFBO1FBQUE7TUFBQTtNQUpyQjtJQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7TUFBQTtJQUFBOzs7O0lBRXFCO0lBQ0E7SUFIckIsU0FFcUIsVUFDQSxTQUhyQjs7Ozs7TUFLQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFPcUI7UUFBQTtRQUFBO01BQUE7TUFDQTtRQUFBO1FBQUE7TUFBQTtNQVJyQjtJQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtnQkFBQTtNQUFBO0lBQUE7Ozs7SUFFcUI7SUFDQTtJQUdBO0lBRkE7SUFDQTtJQUxyQixTQUVxQixVQUNBLFVBR0EsVUFGQSxVQUNBLFNBTHJCOzs7OztNQVNBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFNcUI7UUFBQTtRQUFBO01BQUE7TUFOckI7SUFBQTtnQkFBQTs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUtxQjtnQkFIQTs7O0lBQUE7SUFBQTtnQkFGckI7TUFBQTtJQUFBO0lBTXlGOzs7O0lBTHBFO0lBRUE7SUFDQTtJQUNBO0lBSEE7SUFFcUI7SUFKMUMsU0FDcUIsVUFFQSxVQUNBLFVBQ0EsVUFIQSxVQUVxQixTQUoxQzs7Ozs7TUFTSTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7O0lBQzJDO0lBQ3RCO0lBRnJCLFNBQzJDLFVBQ3RCLFNBRnJCOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLCtFQUFBOzs7OztJQURKO0lBQTJGO0lBQ3ZGO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFFOEY7Ozs7SUFGekU7SUFBckIsU0FBcUIsU0FBckI7Ozs7O0lBTUo7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BRVU7UUFBQTtRQUFBO01BQUE7TUFGVjtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7O0lBQ1U7SUFEVixTQUNVLFNBRFY7Ozs7OztJQW5DSjtnQkFBQTs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUErRTtJQUMzRTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBSXNHO0lBQ3RHO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQXFCO0lBSXlGO0lBQzlHO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQXFCO0lBUXdGO0lBQzdHO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFPc0I7SUFDdEI7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBYztJQUlDO01BQ2Y7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUNZO1FBQUE7UUFBQTtNQUFBO01BRFo7SUFBQTtnQkFBQTs7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUN1RTtJQUN2RTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRTJFO0lBQ3ZEOzs7O0lBdENEO0lBQWdCO0lBQXZDLFNBQXVCLFVBQWdCLFNBQXZDO0lBQ3lCO0lBQXJCLFNBQXFCLFNBQXJCO0lBS3FCO0lBQXJCLFVBQXFCLFNBQXJCO0lBS3FCO0lBQXJCLFVBQXFCLFNBQXJCO0lBU3FCO0lBQXJCLFVBQXFCLFNBQXJCO0lBUWM7SUFBZCxVQUFjLFNBQWQ7SUFLb0M7SUFBcEMsVUFBb0MsVUFBcEM7SUFFVTtJQUFWLFVBQVUsVUFBVjs7SUFGQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7Ozs7O0lDakNKO2dCQUFBOzs7O0lBQUE7S0FBQTtnQkFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-edit-page/ordering-context-edit-page.component.ngfactory.ts